export const editMutations = <const>{
	ND_PR_RETURN_PRINVOICE_SELECT_MAPPER: 'ND_PRIJEMKA_PR_RETURN_SELECT_MAPPER',
	ND_PRIJEMKA_DODAVATEL_SELECT_MAPPER: 'ND_PRIJEMKA_DODAVATEL_SELECT_MAPPER',
};

export const listMutations = <const>{
	ND_PR_RETURN_DODAVATEL_FILTER_SELECT_MAPPER: 'ND_PR_RETURN_DODAVATEL_FILTER_SELECT_MAPPER',
	ND_PR_RETURN_VSTUP_PRAC_FILTER_SELECT_MAPPER: 'ND_PR_RETURN_VSTUP_PRAC_FILTER_SELECT_MAPPER',
	ND_PR_RETURN_STATUS_PRIJEMKY: 'ND_PR_RETURN_STATUS_PRIJEMKY',
	ND_PR_RETURN_FILTER_PRRETURN_SELECT_MAPPER: 'ND_PR_RETURN_FILTER_PRRETURN_SELECT_MAPPER',
};
